'use strict';

/**
 *
 * @category   View
 * @module     community
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabem@gmail.com>
 */

var ColidoLayoutView = require('base/Colido.LayoutView');
var GroupFormView = require('modules/community/views/partials/group-form');

var template = require('modules/community/templates/layout/group-edit-modal.hbs');

var GroupEditModalView = ColidoLayoutView.extend({
    template: template,

    regions: {
        groupFormRegion: '.group-form-region',
    },

    ui: {
        actionClose: '[data-action="close"]',
    },

    events: {
        'click @ui.actionClose': 'actionClose',
    },

    actionClose: function (event) {
        this.trigger('close:modal');
    },

    onRender: function() {
        var groupFormView = new GroupFormView({model: this.model});
        this.groupFormRegion.show(groupFormView);
        this.listenTo(groupFormView, 'group:saved', this.actionClose.bind(this));
    },
});

module.exports = GroupEditModalView;